import { loadDishes } from './storage'
import { buildHistoryFileStem } from './historyFileName'

function firstNonEmptyLines(text) {
  return String(text || '')
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((n) => n.trim())
    .filter(Boolean)
}

function nameListFromRecord(record) {
  if (record.dishNames && record.dishNames.length) {
    return record.dishNames.map((n) => String(n || '').trim()).filter(Boolean)
  }
  return firstNonEmptyLines(record.previewContent)
}

function firstPreviewLine(record) {
  if (!record) return ''
  const fromPreview = firstNonEmptyLines(record.previewContent)[0]
  if (fromPreview) return fromPreview
  if (record.title) return String(record.title).trim()
  if (record.dishNames && record.dishNames[0]) return String(record.dishNames[0]).trim()
  return ''
}

function normalizeOrderDate(raw) {
  const s = String(raw || '').trim()
  let m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/)
  if (!m) {
    m = s.match(/^(\d{4})年(\d{1,2})月(\d{1,2})日?$/)
  }
  if (!m) return ''
  const month = m[2].padStart(2, '0')
  const day = m[3].padStart(2, '0')
  return `${m[1]}-${month}-${day}`
}

/** 预览第一行：日期 + 空格 + 包厢名 */
export function parseDateAndRoom(line) {
  const raw = String(line || '').trim()
  if (!raw) return { orderDate: '', roomName: '' }
  const parts = raw.split(/\s+/)
  const orderDate = normalizeOrderDate(parts[0] || '')
  const roomName = parts.slice(1).join(' ').trim()
  return { orderDate, roomName }
}

function normalizeDishName(name) {
  return String(name || '').replace(/\s+/g, '').trim()
}

function isImportedRecord(record) {
  return Boolean(record && String(record.previewContent || '').trim())
}

function findExactInPool(pool, name) {
  const key = normalizeDishName(name)
  if (!key) return null
  return pool.find((d) => normalizeDishName(d.name) === key) || null
}

function menuNamesForMapping(record) {
  const stem = buildHistoryFileStem(record.perCapita, record.guestCount)
  const source = isImportedRecord(record)
    ? firstNonEmptyLines(record.previewContent)
    : nameListFromRecord(record)
  let names = source.filter((name) => name && name !== stem)
  const header = parseDateAndRoom(names[0] || '')
  if (header.orderDate) {
    names = names.slice(1)
  }
  return names
}

function mapNamesToRecipes(names) {
  const pool = loadDishes()
  const usedCount = {}
  return names.map((name, idx) => {
    const hit = findExactInPool(pool, name)
    if (hit) {
      usedCount[hit.id] = (usedCount[hit.id] || 0) + 1
      const dup = usedCount[hit.id] > 1 ? `__${idx}` : ''
      return {
        id: `${hit.id}${dup}`,
        name: hit.name,
        price: Number(hit.price) || 0,
        cost: Number(hit.cost) || 0,
        category: hit.category
      }
    }
    return {
      id: `hist_${idx}_${name}`,
      name,
      price: 0,
      cost: 0,
      category: 'normal'
    }
  })
}

/**
 * 带入自动配菜的菜品列表。
 * 手动导入（含系统导出 / 非系统导出）：逐条按菜名精确映射菜谱，取单人份售价/成本；未映射到则均为 0。
 * 本系统确认保存的历史：使用当时保存的 dishes。
 */
export function resolveHistoryDishes(record) {
  if (!record) return []
  if (isImportedRecord(record)) {
    return mapNamesToRecipes(menuNamesForMapping(record))
  }
  if (record.dishes && record.dishes.length) {
    return record.dishes.map((d) => ({
      id: d.id,
      name: d.name,
      price: Number(d.price),
      cost: Number(d.cost),
      category: d.category
    }))
  }
  return mapNamesToRecipes(menuNamesForMapping(record))
}

export function historyFormFromRecord(record) {
  if (!record) return null
  const header = parseDateAndRoom(firstPreviewLine(record))
  return {
    orderDate: header.orderDate || record.orderDate || '',
    roomName: header.roomName || record.roomName || '',
    guestCount: record.guestCount,
    perCapita: record.perCapita,
    profitRatePercent: record.profitRatePercent || '',
    needWei: record.needWei === true
  }
}
